import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, ItemHighlight } from '../../../models/filter-models';
import { GearSizeType, VendoringGearType, Rarity } from "../../../models/enums";
import { FilterService } from '../../../services/filter.service';
import { BaseComponent } from '../../../common/base.component';
import { SelectGearSizeComponent } from '../../../common/select/select-gear-size/select-gear-size.component';
import { EquipmentTierPickerComponent } from '../../../common/equipment-tier-picker/equipment-tier-picker.component';
import { EquipmentType } from '../../../models/equipment-type.enum';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { FilterCheckboxGroupComponent } from '../../../common/filter-checkbox-group/filter-checkbox-group.component';
import { CustomRuleStylePickerComponent } from '../../../common/style-picker/custom-rule-style-picker/custom-rule-style-picker.component';

@Component({
  selector: 'app-vendoring-gear',
  imports: [FormsModule, FilterTitleComponent, SelectGearSizeComponent,
    EquipmentTierPickerComponent, SelectComponent, SelectOptionComponent, FilterCheckboxGroupComponent,
    CustomRuleStylePickerComponent],
  templateUrl: './vendoring-gear.component.html',
  styleUrl: './vendoring-gear.component.scss'
})
export class VendoringGearComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input() includeMagics: boolean = false;

  GearSizeType = GearSizeType;
  VendoringGearType = VendoringGearType;
  Rarity = Rarity;
  EquipmentType = EquipmentType;

  showVendoringItemsFilters = false;

  defaultStyle = new ItemHighlight();

  constructor(private filterService: FilterService) {
    super();
  }

  toggleShowVendoringRares = () => {
    this.filter.showVendoringRares = !this.filter.showVendoringRares;
    if (!this.filter.showVendoringRares) {
      this.filter.showVendoringMagics = false;
      this.showVendoringItemsFilters = false;
    }
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }
}

